import * as R from 'ramda'
import { isEmptyOrNil } from 'libs/empty'

import {
  notificationEventStatus,
  eventStatusFromAPI,
} from 'app/main/notification/useNotificationEventStatus'

const unsendAt = R.prop('unsentDate')

export const isUnsent = R.compose(R.not, isEmptyOrNil, unsendAt)

export const isCanceled = R.compose(
  R.equals(notificationEventStatus.canceled.name),
  eventStatusFromAPI,
  R.prop('eventStatus'),
)

export const isEnded = R.compose(
  R.equals(notificationEventStatus.ended.name),
  eventStatusFromAPI,
  R.prop('eventStatus'),
)
